/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";

export const addCategories = createAsyncThunk('category/add', async (data: any, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/category`, data)
    return response
  } catch (error: any) {
    return rejectWithValue(error?.response?.data)
  }
}
);

export const getAllCategories = createAsyncThunk(
  "category/all",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/category", { params });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCategory = createAsyncThunk(
  "category/get",
  async (category_id: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/category/${category_id}`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateCategory = createAsyncThunk(
  "category/update",
  async ({ _id, data }: { _id: string; data: any }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `/admin/category/${_id}`,
        data
      );

      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "category/delete",
  async (category_id: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `/admin/category/${category_id}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

interface CategoryState {
  isLoading: boolean;
  formLoader: boolean;
  category: any;
  allCategories: any;
  error: any;
}

const initialState: CategoryState = {
  isLoading: false,
  formLoader: false,
  category: null,
  allCategories: [],
  error: null,
};

const categorySlice: any = createSlice({
  name: "category",
  initialState,
  reducers: { resetState: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(addCategories.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(addCategories.fulfilled, (state, action) => {
        state.formLoader = false;
        state.category = action.payload?.data?.data;
      })
      .addCase(addCategories.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message;
      })
      .addCase(getAllCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allCategories = action.payload?.data;
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(getCategory.pending, (state) => {
        state.isLoading = true;
        state.category = null;
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.category = action.payload?.data;
      })
      .addCase(getCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateCategory.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.formLoader = false;
        state.category = action.payload?.data?.data;
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message;
      })
      .addCase(deleteCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetState } = categorySlice.actions;
export default categorySlice.reducer;
